import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getSettingsPortalPantry = get('settings.portal.pantry');

export const getPantry = createSelector(getSettingsPortalPantry, get('data'));

export const getIsFetching = createSelector(
  getSettingsPortalPantry,
  get('fetching')
);
export const getIsFetched = createSelector(
  getSettingsPortalPantry,
  get('fetched')
);
export const getFetchingError = createSelector(
  getSettingsPortalPantry,
  get('fetchingError')
);

export const getIsSaving = createSelector(
  getSettingsPortalPantry,
  get('saving')
);
export const getIsSaved = createSelector(getSettingsPortalPantry, get('saved'));
export const getSavingError = createSelector(
  getSettingsPortalPantry,
  get('savingError')
);
